import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { wfm: () => import('./WfmPage.vue') },
} satisfies FeatureRoutes
